/**
 *
 * Button
 *
 */

import React, { memo, FunctionComponent, Children } from 'react';
import {
  A,
  StyledButtonIcon,
  StyledButtonIconTransparent,
  StyledButtonPrimary,
  StyledButtonSecondary,
  StyledButtonTertiary,
  StyledButtonWarn,
  StyledLinkButton,
  StyledLinkButtonPrimary,
} from './styles';

interface IProps {
  to?: any;
  primary?: boolean;
  onClick?: any;
  btn?: any;
  children?: any;
  icon?: boolean;
  transparent?: boolean;
  disabled?: any;
  className?: any;
  secondary?: boolean;
  warn?: boolean;
  title?: string;
}

const Button: FunctionComponent<IProps> = ({
  to,
  primary,
  secondary,
  onClick,
  btn,
  icon,
  transparent,
  children,
  disabled,
  className,
  warn,
  title,
}) => {
  let button;
  if (!to) {
    primary
      ? (button = (
          <StyledButtonPrimary
            className={className}
            disabled={disabled}
            onClick={onClick}
            title={title}
          >
            {Children.toArray(children)}
          </StyledButtonPrimary>
        ))
      : secondary
      ? (button = (
          <StyledButtonTertiary
            className={className}
            disabled={disabled}
            onClick={onClick}
            transparent={transparent}
            title={title}
          >
            {Children.toArray(children)}
          </StyledButtonTertiary>
        ))
      : icon
      ? transparent
        ? (button = (
            <StyledButtonIconTransparent
              className={className}
              disabled={disabled}
              onClick={onClick}
              title={title}
            >
              {Children.toArray(children)}
            </StyledButtonIconTransparent>
          ))
        : (button = (
            <StyledButtonIcon
              className={className}
              disabled={disabled}
              onClick={onClick}
              title={title}
            >
              {Children.toArray(children)}
            </StyledButtonIcon>
          ))
      : warn
      ? (button = (
          <StyledButtonWarn
            className={className}
            disabled={disabled}
            onClick={onClick}
            title={title}
          >
            {Children.toArray(children)}
          </StyledButtonWarn>
        ))
      : (button = (
          <StyledButtonSecondary
            className={className}
            disabled={disabled}
            onClick={onClick}
            title={title}
          >
            {Children.toArray(children)}
          </StyledButtonSecondary>
        ));
  } else {
    btn
      ? primary
        ? (button = (
            <StyledLinkButtonPrimary
              className={className}
              to={to}
              onClick={onClick}
              title={title}
            >
              {Children.toArray(children)}
            </StyledLinkButtonPrimary>
          ))
        : (button = (
            <StyledLinkButton
              className={className}
              to={to}
              onClick={onClick}
              title={title}
            >
              {Children.toArray(children)}
            </StyledLinkButton>
          ))
      : (button = (
          <A className={className} to={to} onClick={onClick}>
            {Children.toArray(children)}
          </A>
        ));
  }

  return button;
};

export default memo(Button);
